<article
    class="event-card"
    [class.compact]="compact"
    [style.--ev-accent]="accent">

    <a class="card-link" [routerLink]="['/events/e', event.slug]">
        <span class="sr-only">{{ event.title }}</span>
    </a>

    <div class="card-media" *ngIf="!compact && event.image_url">
        <img [src]="event.image_url" [alt]="''" loading="lazy" decoding="async" />
        <div class="media-scrim" aria-hidden="true"></div>
        <div class="media-badges">
            <app-audience-pill [audience]="event.audience" [onImage]="true"></app-audience-pill>
        </div>
    </div>

    <div class="card-head">
        <app-date-chip [date]="startDate"></app-date-chip>

        <div class="head-text">
            <a
                *ngIf="showSeries && event.series"
                class="series-tag"
                [routerLink]="['/events/series', event.series.slug]">
                {{ event.series.title }}
            </a>

            <h3 class="card-title">{{ event.title }}</h3>
            <p class="card-subtitle" *ngIf="event.subtitle">{{ event.subtitle }}</p>

            <app-audience-pill
                *ngIf="compact || !event.image_url"
                [audience]="event.audience"></app-audience-pill>
        </div>
    </div>

    <div class="card-meta">
        <div class="meta-row" *ngIf="showClock">
            <span class="material-symbols-outlined" aria-hidden="true">schedule</span>
            <span>
                {{ startDate | date: "HH:mm" }}<ng-container *ngIf="endDate">
                    – {{ endDate | date: "HH:mm" }}</ng-container>
            </span>
        </div>

        <div class="meta-row" *ngIf="event.time_note">
            <span class="material-symbols-outlined" aria-hidden="true">schedule</span>
            <span>{{ event.time_note }}</span>
        </div>

        <div class="meta-row" *ngIf="event.location">
            <span class="material-symbols-outlined" aria-hidden="true">place</span>
            <span>{{ event.location }}</span>
        </div>

        <div class="meta-row" *ngIf="event.age_range">
            <span class="material-symbols-outlined" aria-hidden="true">child_care</span>
            <span>{{ event.age_range }}</span>
        </div>

        <div class="meta-row" *ngIf="event.speaker">
            <span class="material-symbols-outlined" aria-hidden="true">person</span>
            <span>{{ event.speaker }}</span>
        </div>
    </div>

    <p class="card-description" *ngIf="event.description">{{ event.description }}</p>

    <div class="card-foot">
        <span class="price" *ngIf="event.price_text">{{ event.price_text }}</span>
        <span class="recurring" *ngIf="event.rrule">
            <span class="material-symbols-outlined" aria-hidden="true">repeat</span>
            Recurring
        </span>
        <span class="cta">
            {{ registersHere ? "Register" : "Details" }}
            <span class="material-symbols-outlined" aria-hidden="true">arrow_forward</span>
        </span>
    </div>
</article>
